// src/modules/purityAnalyzer/constants/purityConstants.js
// Constants for the Gold Purity Analyzer module (mirrors backend purityEnums).

export const API_ENDPOINTS = {
  CALIBRATIONS: '/purity/calibrations',
  TESTS: '/purity/tests',
  LEARNING: '/purity/learning',
  VERSIONS: '/purity/versions',
  MACHINES: '/purity/machines',
  DASHBOARD: '/purity/dashboard',
  ANALYTICS: '/purity/analytics',
  DEDUCTION_SETTINGS: '/purity/deduction-settings',
};

export const PURITY_CATEGORY = {
  HM: 'HM',
  NON_HM: 'NON_HM',
};

export const PURITY_CATEGORY_LABELS = {
  HM: 'Hallmarked (HM)',
  NON_HM: 'Non-Hallmarked (Non-HM)',
};

export const CALIBRATION_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  ARCHIVED: 'ARCHIVED',
};

export const CALIBRATION_STATUS_COLORS = {
  ACTIVE: 'green',
  INACTIVE: 'default',
  ARCHIVED: 'orange',
};

export const VERSION_STATUS_COLORS = {
  DRAFT: 'blue',
  ACTIVE: 'green',
  ARCHIVED: 'orange',
};

export const XRF_STATUS_COLORS = {
  PENDING: 'gold',
  VERIFIED: 'green',
  SKIPPED: 'default',
};

export const LEARNING_STATUS_COLORS = {
  NONE: 'default',
  PROPOSED: 'blue',
  APPROVED: 'green',
  REJECTED: 'red',
};

export const FLUID_CONDITION_META = {
  STABLE: { color: 'green', label: 'Stable' },
  WARM: { color: 'orange', label: 'Warm Fluid' },
  COLD: { color: 'blue', label: 'Cold Fluid' },
  CHECK_FLUID: { color: 'red', label: 'Check Fluid' },
};

export const TRANSACTION_KIND = {
  WALK_IN_CASE: 'WALK_IN_CASE',
  PLEDGE: 'PLEDGE',
};

export const TRANSACTION_KIND_LABELS = {
  WALK_IN_CASE: 'Walk-In Case',
  PLEDGE: 'Pledge Release',
};

export const KARAT_COLORS = {
  '24K': '#d4a017',
  '23K': '#d9a62e',
  '22K': '#c9962b',
  '20K': '#b08a3e',
  '18K': '#9a7b4f',
  '<18K': '#8c8c8c',
};

// Purity gauge color scale (low → high)
export const purityColor = (p) => {
  if (p >= 99) return '#52c41a';
  if (p >= 91) return '#a0d911';
  if (p >= 80) return '#faad14';
  if (p >= 70) return '#fa8c16';
  return '#f5222d';
};

export const confidenceColor = (c) => {
  if (c >= 90) return '#52c41a';
  if (c >= 75) return '#faad14';
  return '#f5222d';
};

export const QUALITY_COLORS = {
  EXCELLENT: 'green',
  GOOD: 'cyan',
  FAIR: 'orange',
  RECALIBRATE: 'red',
};

export const CHART_KEYS = [
  { key: 'purity-timeline', label: 'Purity Timeline' },
  { key: 'density-timeline', label: 'Density Timeline' },
  { key: 'calibration-drift', label: 'Calibration Drift' },
  { key: 'temperature-drift', label: 'Temperature Drift' },
  { key: 'purity-distribution', label: 'Purity Distribution' },
  { key: 'daily-tests', label: 'Daily Tests' },
  { key: 'branch-comparison', label: 'Branch Comparison' },
  { key: 'operator-comparison', label: 'Operator Comparison' },
  { key: 'calibration-history', label: 'Calibration History' },
];
